import { useCallback, useMemo } from 'react'
import { makeVar } from '@apollo/client'

import { useReactiveVar } from '@apollo/client/react'

const isOpenVar = makeVar(localStorage.getItem('is_sidebar_open') ?? 'true')

export function useIsOpen(): [boolean, () => void] {
  const isOpen = useReactiveVar(isOpenVar)

  const isOpenBool = useMemo(() => {
    return isOpen === 'true' ? true : false
  }, [isOpen])

  const onToggle = useCallback(() => {
    const newIsOpen = !isOpenBool

    try {
      localStorage.setItem('is_sidebar_open', newIsOpen.toString())
    } catch {
      /* empty */
    }

    isOpenVar(newIsOpen.toString())
  }, [isOpenBool])

  return [isOpenBool, onToggle]
}
